import Formatters from "@/mixins/formatters";
import CampaignsFilter from "@/components/CampaignsFilter";

export default {
    components: { CampaignsFilter },
    mixins: [Formatters],
    data() {
        return {
            activeFilter: null,
            toDelete: null,
            confirmDelete: false,
            toArchive: null,
            confirmArchive: false,
            refreshing: false
        }
    },
    computed: {
        list() {
          return this.$store.getters[`campaigns/list${this.capitalize(this.type)}`];
        },
        domainInfo() {
          return this.$store.state.domains.item;
        },
        coloredFilters() {
          return this.filters.map(f => { return { color: this.getCampaignStateColor(f.value), ...f } });
        }
      },
      watch: {
        activeFilter(newVal) {
          if(!this.$store.state.campaigns.archiveLoaded && newVal.indexOf('*ARCHIVED*') >= 0) {
            console.debug('Loading archived campaigns...');
            this.$store.dispatch('campaigns/listArchived', { domainID: this.domain, state: 'ARCHIVED' });
          }
        }
      },
      methods: {
        formatSegmentationType(v) {
          switch(v) {
              case 'AMOUNT_SPENT': return this.$t('campaigns.segmentationTypes.amountSpent.title');
              case 'ORDER_COUNT': return this.$t('campaigns.segmentationTypes.ordersCount.title');
              case 'TAG': return this.$t('campaigns.segmentationTypes.tag.title');
          }
        },
        formatEvaluationPeriod(item) {
          if(item.evaluationPeriod?.window) {
            this.formatTimeWindow(item.evaluationPeriod.window)
          } else if(item.evaluationPeriod?.from && item.evaluationPeriod?.to) {
            return `${this.formatDate(item.evaluationPeriod.from)} - ${this.formatDate(item.evaluationPeriod.to)}`;
          }
          return null;
        },
        capitalize(s) {
            return `${s.substring(0,1).toUpperCase()}${s.substring(1)}`;
        },
        loadCampaigns() {
          if (!this.list) {
            this.refreshCampaigns();
          }
        },
        async refreshCampaigns() {
          this.refreshing = true;
          await this.$store.dispatch("campaigns/list", { domainID: this.domain, sortDirection: 'DESC' });
          this.refreshing = false;
        },
        archiveCampaign(id) {
          this.listLoading = true;
          this.confirmArchive = false;
          // set priority to null so the campaign is not feteched during initial load that has the priority in index
          this.$store.dispatch('campaigns/updateCampaign', { id, state: 'ARCHIVED', priority: null }).then(() => this.listLoading = false);
        },
        deleteCampaign(id) {
          this.listLoading = true;
          this.confirmDelete = false;
          this.$store.dispatch('campaigns/remove', { id }).then(() => this.listLoading = false);
        },
        disableCampaign(id) {
          this.listLoading = true;
          this.$store.dispatch('campaigns/updateCampaign', { id, state: 'DISABLED' }).then(() => this.listLoading = false);
        },
        duplicateCampaign(id) {
          this.listLoading = true;
          this.$store.dispatch('campaigns/duplicate', { id, localizedTitle: this.$t('common.copy.title'), domain: this.domainInfo }).then(() => this.listLoading = false);
        },
        getCampaignStep(c) {

          let params = { campaign: c.id, medium: c.medium.toLowerCase() || 'email' };
          let name;
          if(c.state == 'DISABLED') {
            name = 'campaign-summary-dynamic';
          }
          else if(!c.segmentationType && c.scheduleType != 'SMART_WARM_UP') {
            name = 'campaign-segment';
          }
          else if(!c.subjects?.length) {
            name = 'campaign-setup-dynamic';
          }
          else if(c.schedule) {
            name = 'campaign-summary-dynamic';
          } else {
            name = 'campaign-design-dynamic'; 
          }
          return {name, params};
        },
        filterCampaigns (value, search, item) {
          if(!search) {
            return true;
          }
          
          return search.indexOf(`*${item.state}*`) >= 0;
        },
      },
      created() {
        this.loadCampaigns();
      },
      beforeRouteLeave (to, from, next) {
        if(to.name == 'add-campaign' || to.name.indexOf('campaign-') == 0) {
          this.$store.commit('ui/dynamicEntryPoint', { value: `campaigns-${this.type}` });
        }
        next();
      }
}